export const LOGIN_PHRASES = {
    PASSWORD: 27,
    LOGIN: 28,
    REMEMBER_ME: 29,
    FORGOT_PASSWORD: 30,
    SUCCESS: 315,
    MEMBER_LOGIN: 1767,
    SUBMIT: 1972,
    VERIFICATION_CODE: 3817,
    SIGN_UP: 15929,
    EMAIL: 13231,
    BY_EMAIL: 15930,
    BY_TOTP: 18991,
    BY_SMS: 19631,
    ENTER_RECAPTCHA: 10860,
    SEND_CODE: 3801,
    REQUIRED_FIELD: 966,
    PASS_TOO_SHORT: 747,
    CONFIRM_PASS_MUST_MATCH: 363,
    ENTER_VALID_EMAIL: 354,
    ONLY_LATIN: 15932,
    NO_ACCOUNT: 15933,
    CONFIRM_NOT_ROBOT: 15934,
    CONFIRM_LOGIN: 15935,
    VERIFY: 15936,
    UNUSUAL_ACTIVITY: 15937,
    GET_CODE: 15938,
    NEXT: 84,
    ENTER_OTC: 15939,
    SENT_OTC: 15940,
    USE_OTC_FROM_APP: 15941,
    ENTER_CODE_BELOW: 15942,
    NEXT_CODE_IN: 15943,
    RESEND_CODE_IN: 15944,
    RESEND_CODE: 15945,
    SECS: 19279,
    LOGIN_TO_PROCEED: 3756,
    SENSITIVE_AREA: 3542,
    VERIFY_EMAIL: 1785,
    RESEND_CONFIRMATION_EMAIL: 16031,
    PASSWORD_UPDATED: 2824,
    CONTINUE: 2199,
    BACK: 3477,
} as const;

export const PASSWORD_RESET_PHRASES = {
    ENTER_YOUR_EMAIL: 3539,
    WE_WILL_EMAIL_PASSWORD_RESET: 3341,
    EMAIL: 13231,
    NEW_PASSWORD: 2827,
    PASSWORD_MUST_BE_AT_LEAST_6_CHARS: 747,
    BROKEN_LINK: 1344,
    NEW_EMAIL: 2827,
    SEND: 188,
    BACK_TO_LOGIN_PAGE: 15947,
    REPEAT_NEW_PASSWORD: 15948,
    PASSWORD_REQUIREMENTS: 15949,
    SET_NEW_PASSWORD: 15950,
    PASSWORD_UPDATE_EMAIL_SENT: 3338,
    CREATE_PASSWORD: 19698,
    CREATE_PASSWORD_DESCRIPTION: 19699,
};

export const ENROLL_PHRASES = {
    COMPLETE_ACCOUNT_SETUP: 20647,
    PROVIDE_EMAIL_AND_PASSWORD: 20648,
    EMAIL: 13231,
    PASSWORD: 27,
    CONFIRM_PASSWORD: 43,
    SUBMIT: 1972,
};
